import { Error, InputBlock, InputElement, InputGroup, Label, MaskedInputElement } from "./style";

const Input = ({
  value,
  onChange = () => null,
  onBlur = () => null,
  onClick = () => null,
  onFocus = () => null,
  type = "text",
  placeholder = null,
  required = false,
  mask = null,
  normalize = null,
  label = null,
  touched = false,
  error = null,
  success = false,
  disabled,
  translate = "no",
  ...rest
}) => {
  const handleChange = e => {
    if (normalize) {
      onChange(normalize(e.target.value));
    } else {
      onChange(e.target.value);
    }
  };

  return (
    <InputGroup>
      <InputBlock isError={touched && error} isSuccess={success}>
        {label && (
          <Label translate={translate}>
            {label} {required && <span>*</span>}
          </Label>
        )}
        {mask ? (
          <MaskedInputElement
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            type={type}
            onBlur={onBlur}
            onClick={onClick}
            onFocus={onFocus}
            disabled={disabled}
            mask={mask}
            translate={translate}
            {...rest}
          />
        ) : (
          <InputElement
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            type={type}
            onBlur={onBlur}
            onClick={onClick}
            onFocus={onFocus}
            disabled={disabled}
            translate={translate}
            {...rest}
          />
        )}
      </InputBlock>
      {touched && error && <Error>{error}</Error>}
    </InputGroup>
  );
};

export default Input;
